export default __webpack_public_path__ + "static/media/item_2@3x.ec2d3244.png";